import { Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { DadosContratosModel } from '../model/dados-contrato.model';



@Component({
  selector: 'modal-contrato.component',
  templateUrl: './modal-contrato.component.html',
  styleUrls: ['./modal-contrato.component.css']
})
export class ModalContratoComponent implements OnInit {

  @ViewChild('dadosContratos') myDiv: ElementRef;

  infoContratos :DadosContratosModel;
  visualizaContratoPF :boolean;
  visualizaContratoPJ :boolean;
  visualizaRenovaContratoPF :boolean;
  visualizaRenovaContratoPJ :boolean;


  constructor(
    public dialogRef: MatDialogRef<ModalContratoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  innerHtml: string;

  ngOnInit() {
    this.setarDadosTela();
  }

  setarDadosTela() {
    
    this.infoContratos = this.data.dadosContratos;
    this.visualizaContratoPF = this.infoContratos.tipoInscricao !== "1" && !this.infoContratos.isRenovacao;
    this.visualizaContratoPJ = this.infoContratos.tipoInscricao === "1" && !this.infoContratos.isRenovacao;
    this.visualizaRenovaContratoPF = this.infoContratos.tipoInscricao !== "1" && this.infoContratos.isRenovacao;
    this.visualizaRenovaContratoPJ = this.infoContratos.tipoInscricao === "1" && this.infoContratos.isRenovacao;
  }

  onClose() {
    this.dialogRef.close();
  }


}

